import React from 'react';

import { useTranslation } from '@shared/core';
import { ConsoleEmptyState } from '@apps/stays/components/ConsoleEmptyState/ConsoleEmptyState';

type EmptyStateProps = Readonly<{
  onReset?: () => void;
  showResetButton?: boolean;
  hasSearchLocation?: boolean;
}>;

export const EmptyState = ({ onReset, showResetButton, hasSearchLocation = true }: EmptyStateProps) => {
  const { tq } = useTranslation('carRentalConsole');

  return (
    <ConsoleEmptyState
      onReset={onReset}
      showResetButton={showResetButton}
      resetButtonLabel={tq`Reset filters`}
      title={hasSearchLocation ? tq`No rental cars match your search` : tq`Search for a pick-up location`}
      content={
        hasSearchLocation
          ? tq`Try adjusting your filters or search a different pick-up location and dates.`
          : tq`Enter a pick-up location and dates above to see rental cars with exclusive event rates.`
      }
    />
  );
};
